import { setTourId } from 'src/redux/actions/helpmenu'
import Action from 'src/redux/action'

type State = {
  tourId?: string
}

const helpmenu = (state: State = {}, action: Action): State => {
  switch (action.type) {
    case setTourId.type:
      return {
        ...state,
        tourId: action.tourId,
      }
    default:
      return state
  }
}

export default helpmenu
